import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { TextField } from '@mui/material';
import {
    updateInstrument,
    createInstrument,
    getInstrumentDataById
} from '../../../../services/clinicPortalServices/instrumentService.js';
import { getUserFullName } from '../../../../services/common/util.js';
import toastr from 'toastr';

export default class InstrumentDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            instrumentId: this.props && this.props.instrumentId ? this.props.instrumentId : '',
            name: '',
            type: this.props.type ? this.props.type : '',
            serialNumber: '',
            sshTunnel: '',
            uid: '',
            errors: []
        };
    }

    componentDidMount() {
        if (this.state.instrumentId) {
            this.loadDetails();
        }
    }

    loadDetails = () => {
        getInstrumentDataById(this.state.instrumentId).then((res) => {
            const instrumentInfo = res.data;
            this.setState({
                name: instrumentInfo.name,
                type: instrumentInfo.type,
                serialNumber: instrumentInfo.serialNumber,
                sshTunnel: instrumentInfo.sshTunnel,
                uid: instrumentInfo.uid
            });
        });
    };

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    };

    hasError = (key) => {
        return this.state.errors.indexOf(key) !== -1;
    };

    saveChanges = () => {
        let errors = [];
        if (!this.state.name) {
            errors.push('name');
        }
        if (!this.state.type) {
            errors.push('type');
        }
        this.setState({ errors: errors });
        if (errors.length > 0) {
            return false;
        }

        let instrumentInfo = {
            name: this.state.name,
            type: this.state.type,
            serialNumber: this.state.serialNumber,
            sshTunnel: this.state.sshTunnel,
            uid: this.state.uid
        };

        if (this.state.instrumentId) {
            instrumentInfo._id = this.state.instrumentId;
            updateInstrument(instrumentInfo).then((res) => {
                this.props.handleClose();
                this.props.context.componentParent.loadGridData();
            });
        } else {
            instrumentInfo.createdBy = getUserFullName();
            createInstrument(instrumentInfo).then((res) => {
                this.props.handleClose();
                this.props.context.componentParent.loadGridData();
                toastr.success('Instrument is created successfully');
            });
        }
    };

    render() {
        return (
            <div>
                <div className="row form-row">
                    <div className="col-12">
                        <div className="form-group">
                            <TextField
                                label="Name *"
                                name="name"
                                value={this.state.name}
                                onChange={this.handleChange}
                            />
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="form-group">
                            <TextField
                                name="type"
                                label="Type *"
                                value={this.state.type}
                                onChange={this.handleChange}
                                disabled={this.props.type ? true : false}
                            />
                            <div className={this.hasError('type') ? 'inline-errormsg' : 'hidden'}>
                                <i className="fa fa-exclamation-circle" aria-hidden="true">
                                    &nbsp;This field is required.
                                </i>
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="form-group">
                            <TextField
                                label="Serial Number"
                                name="serialNumber"
                                value={this.state.serialNumber}
                                onChange={this.handleChange}
                            />
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="form-group">
                            <TextField
                                label="SSH Tunnel"
                                name="sshTunnel"
                                value={this.state.sshTunnel}
                                onChange={this.handleChange}
                            />
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="form-group">
                            <TextField label="UID" name="uid" value={this.state.uid} onChange={this.handleChange} />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div
                        className="col-12"
                        style={{
                            paddingTop: '10px',
                            borderTop: '1px solid rgba(0,0,0,.2'
                        }}
                    >
                        <Button
                            style={{ float: 'right', marginLeft: '10px' }}
                            variant="primary"
                            onClick={this.saveChanges}
                        >
                            Save Changes
                        </Button>
                        <Button style={{ float: 'right' }} variant="secondary" onClick={this.props.handleClose}>
                            Close
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}
